import { useQuery } from '@tanstack/react-query';
import { getTenantSiteTypes, TenantSiteTypesResponse } from '@/services/tenants';

/**
 * @param siteType When provided (e.g. current admin site), API returns only site types in that family.
 */
export const useTenantSiteTypes = (siteType?: string) => {
  return useQuery<TenantSiteTypesResponse>({
    queryKey: ['tenants', 'site-types', siteType ?? 'all'],
    queryFn: () => getTenantSiteTypes(siteType),
  });
};
